<div [ngClass]="{'form-group': showLabel}">
  <wm-de-label
    [entity]="entity"
    [for]="entity.templateCode"
    [displayOnly]="true"
    *ngIf="showLabel"
  ></wm-de-label>
  <input
    *ngFor="let i of listEntity.selectedTextValues"
    type="text"
    readonly
    [ngStyle]="{ 'padding-top': !showLabel ? '0px' : '' }"
    class="form-control-plaintext"
    [id]="entity.templateCode"
    [value]="i.text"
    selected="i.text==value"
  />
</div>
